const isEmpty = (list) => {
    return !(list && list.length > 0);
};

const listUtils = {
    isEmpty,
};

export default listUtils;
